import styled, { css } from 'styled-components';

export const CirlcleSpinner = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  animation: spin 2s linear infinite;
  text-align: left;
  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);

      -transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);

      -transform: rotate(360deg);
    }
  }
  ${props =>
    props.bkFlt &&
    css`
      position: absolute;
      left: 10px;
      top: ${props.isFareFamily ? '14px' : '6px'};
    `}
`;

export const CirlcleSpinnerInside = styled.span`
  width: 100%;
  height: 50%;
  position: absolute;
  margin-top: 50%;
  background: linear-gradient(90deg, rgb(250, 250, 250), rgb(200, 200, 200));

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    margin-top: -50%;
    background: linear-gradient(90deg, rgb(150, 150, 150), rgb(190, 190, 190));
  }
  &:after {
    content: '';
    width: 80%;
    height: 160%;
    position: absolute;
    margin-top: -40%;
    margin-left: 10%;
    background: white;
    border-radius: 50%;
  }
  ${props =>
    props.bkFlt &&
    `
   &:before {
    background: linear-gradient(90deg, ${
      props.isFareFamily ? '#f37638' : '#2276E3'
    }, rgb(190, 190, 190));
   }
   &:after {
    background: ${props.isFareFamily ? '#f37638' : '#2276E3'};
   }
    `}
`;
